import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-svg-loader',
  templateUrl: './svg-loader.component.html',
  styleUrls: ['./svg-loader.component.scss']
})
export class SvgLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
